import OTPField from './OTPField';

export default OTPField;